<div class="w-100">
    <div class="page-info">
        <h3 style="margin: 25px; font-weight: 500; font-size:25px; color: #2a457a;">Transactions Mapping</h3>
    </div>
    <div class="page-next"><mat-icon mat-list-icon style="padding: 1px;"
            routerLink="/daybook">arrow_circle_right</mat-icon>
    </div>
</div>

<div class="table-container" style="margin-left: 20px; margin-right: 20px;">
    <div class="w-100 border-p">
        <div class="mt-10 w-100 ">
            <!-- Financial Year -->
            <mat-form-field class="w-20 pl-20" appearance="outline">
                <mat-label class="custom-mat-label">Financial Year</mat-label>
                <mat-select matNativeControl required [(ngModel)]="l_formData.finyearmstId">
                    <mat-select-trigger>
                        {{ lFN_GetFinancialYearText(l_formData.finyearmstId) }}
                    </mat-select-trigger>
                    <mat-option *ngFor="let l_financialyear of l_financialYearList"
                        [value]="l_financialyear.finyearmstId">
                        <div class="option-container">
                            <span>{{ l_financialyear.finyear }}</span>
                            <ng-container *ngIf="l_financialyear.status">
                                <mat-icon class="active-icon">check_circle</mat-icon>
                            </ng-container>
                        </div>
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Category name -->
            <mat-form-field class="w-20 pl-20 " appearance="outline">
                <mat-label class="custom-mat-label">Txncategory</mat-label>
                <mat-select matNativeControl required [(ngModel)]="l_formData.txncategoryId">
                    <mat-option *ngFor="let l_category of l_categoryList" [value]="l_category.txncategoryId">
                        {{ l_category.name }}</mat-option>
                </mat-select>
            </mat-form-field>

            <!-- From Date - To Date -->
            <!-- <mat-form-field class="w-20 pl-20" appearance="outline">
                <mat-label  class="custom-mat-label">From Date - To Date</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate matInput placeholder="Start date" />
                    <input matEndDate matInput placeholder="End date" />
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field> -->

            <!-- From Date - To Date -->
            <mat-form-field class="w-20 pl-20 ml-5" appearance="outline">
                <mat-label class="custom-mat-label">From Date - To Date</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                <input matStartDate matInput placeholder="Start date" [(ngModel)]="l_formData.fromDate"/>
                <input matEndDate matInput placeholder="End date" [(ngModel)]="l_formData.toDate"/>
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>            

            <mat-slide-toggle class="w-20 pl-20" [checked]="l_isMapped" (change)="lFN_OnToggleChange($event)">
                <mat-label class="custom-mat-label">{{ l_mappedUnmappedLabel }}</mat-label>
            </mat-slide-toggle>

            <button mat-raised-button color="primary" class="custom-button-blue" (click)="lFN_SearchTransactionsMappings();">Search Mappings
            </button>
        </div>
    </div>
    <div class="w-100 border-p mt-10">
        <div class="mt-10 w-100 ">
            <!-- Search Number -->
            <mat-form-field class="w-30 pl-20" appearance="outline">
                <mat-label class="custom-mat-label">Search by receipt number</mat-label>
                <input matInput placeholder="Enter receipt number" [(ngModel)]="l_formData.receiptNo">
            </mat-form-field>

            <!-- amount search -->
            <mat-form-field class="w-30 pl-20" appearance="outline">
                <mat-label class="custom-mat-label">Search by amount</mat-label>
                <input matInput placeholder="Enter amount" [(ngModel)]="l_formData.amount">
            </mat-form-field>
        </div>
    </div>

    <div class="w-100 border-p mt-10">
        <div class="mt-10 w-100 mb-10">
            <mat-accordion class="custom-mat-accordion">
                <mat-expansion-panel *ngFor="let l_accountsMapping of l_accountsHeaderMappingList; index as i;">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-panel-title">
                            <div class="custom-icon-container">
                                <mat-icon class="mat-icon-custom">lens</mat-icon>
                                <span class="icon-number">{{ i + 1 }}</span>
                            </div>
                            <span class="mat-accordion-col-small"><mat-label class="custom-mat-label-accordion">Book No.</mat-label> {{ l_accountsMapping.bookNo }}</span>
                            <span class="mat-accordion-col-med"><mat-label class="custom-mat-label-accordion">Receipt No.</mat-label> {{ l_accountsMapping.accountsDetails.receiptNo }}</span>
                            <span class="mat-accordion-col-med"><mat-label class="custom-mat-label-accordion">Amount</mat-label> {{ l_accountsMapping.amount }}</span>
                            <span class="mat-accordion-col-med"><mat-label class="custom-mat-label-accordion">Txndate</mat-label> {{ lFN_GetFromattedDate(l_accountsMapping.transaction.txnDate) }}</span>
                            <span class="mat-accordion-col-large"><mat-label class="custom-mat-label-accordion">Name</mat-label> {{ l_accountsMapping.accountsDetails.firstName + ' ' + l_accountsMapping.accountsDetails.lastName }}</span>
                            <span class="mat-accordion-col-large"><mat-label class="custom-mat-label-accordion">Purpose</mat-label> {{ l_accountsMapping.purpose.name }}</span>
                        </mat-panel-title>
                        <mat-panel-description class="mat-panel-description">
                            <button mat-icon-button (click)="lFN_ViewReceipt(l_accountsMapping)">
                                <mat-icon title="View Details" style="-webkit-text-fill-color: #2a457a">visibility</mat-icon>
                            </button>
                            <!-- Tooltip Button -->
                            <button mat-icon-button 
                                [matTooltip]="(l_accountsMapping.purpose?.name || '') + ' ' +
                                         (l_accountsMapping.modeOfPayment || '') + ' ' +
                                         (l_accountsMapping.modeTranId || '') + ' ' +
                                         (l_accountsMapping.modeBankName || '')"
                                matTooltipClass="custom-tooltip">
                                <mat-icon title="Show Data" style="-webkit-text-fill-color: #2a457a">info</mat-icon>
                            </button>                         
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div>
                        <mat-form-field class="w-30 pl-20" appearance="outline">
                        <mat-label class="custom-mat-label">Credit To</mat-label>
                        <!-- Credit To -->
                        <mat-select [(ngModel)]="l_accordionData[i].creditToId">
                            <mat-option *ngFor="let l_creditTo of l_creditToList" [value]="l_creditTo.ledgerHeadId">
                            {{ l_creditTo.name }}
                            </mat-option>
                        </mat-select>
                        </mat-form-field>
                        <mat-form-field class="w-30 pl-20" appearance="outline">
                        <mat-label class="custom-mat-label">Debit To</mat-label>
                        <!-- Debit To -->
                        <mat-select [(ngModel)]="l_accordionData[i].debitToId">
                            <mat-option *ngFor="let l_debitTo of l_debitToList" [value]="l_debitTo.ledgerHeadId">
                            {{ l_debitTo.name }}
                            </mat-option>
                        </mat-select>
                        </mat-form-field>
                        <button mat-button class="mat-button-small" (click)="lFN_SaveMappingTransaction(l_accountsMapping, i);">{{ l_btnLabel }}</button>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</div>